import { CloudDownloadOutlined } from '@ant-design/icons';
import { EssityDatePicker } from '@components/shared/EssityDateTime';
import { DownloadFile } from '@components/shared/file/FileDownloadFunctions';
import { LoadingView } from '@components/shared/import/LoadingView';
import { IsolatedModal } from '@components/shared/modals/IsolatedModal';
import { mapEssityFiltersToSieveFilters } from '@components/shared/paginatedEssityTable/SieveModels';
import { ajaxByUser } from '@helper/api';
import { DateFormat } from '@helper/formatHelpers';
import { useRootData } from '@hooks/hook';
import { getEssityApiClient } from '@services/EssityApi';
import { FileType } from '@services/src/models';
import { Button, DatePicker, Dropdown, Menu, Space } from 'antd';
import { CenteredRow } from 'layout/CenteredRow';
import { Moment } from 'moment';
import React, { useState } from 'react';
import { IGridStore } from 'stores/GridStore';
import { Formik, Form } from 'formik';

import styles from './styles/Reports.module.less';
import { FFieldLabel } from 'forms/FormikFormItems';
import { DictionarySelect } from 'forms/DictionarySelect';
import { DictionariesConstants } from '@services/DictionariesConstants';
import DictionaryFilter from '@components/shared/DictionaryFilter';
import { IDictionaryStore } from 'stores/DictionaryStore';
import { voivodeship } from '@services/mappers/Voivodeship';

interface IFormValues {
	voivodeships: number[];
	month?: Moment;
	year?: Moment;
	fileType?: FileType;
}

export const PharmacyTaxNotesReport = () => {
	const [visible, setVisible] = useState<boolean>(false);
	const [isBusy, setIsBusy] = useState<boolean>(false);

	const gridStore: IGridStore = useRootData((store) => store.gridStore);
	const dictionaryStore: IDictionaryStore = useRootData(
		(store) => store.dictionaryStore
	);

	const initialValues: IFormValues = {
		voivodeships: [],
		month: undefined,
		year: undefined,
		fileType: undefined,
	};

	const menu = (setFieldValue: (field: string, value: any) => void) => (
		<Menu>
			<Menu.Item
				key="1"
				onClick={() => {
					setFieldValue('fileType', FileType.CSV);
					setVisible(true);
				}}
			>
				Export data as CSV
			</Menu.Item>
			<Menu.Item
				key="2"
				onClick={() => {
					setFieldValue('fileType', FileType.XLSX);
					setVisible(true);
				}}
			>
				Export data as XLSX
			</Menu.Item>
		</Menu>
	);

	const handleCancel = (resetForm: () => void) => {
		setVisible(false);
		setIsBusy(false);
		gridStore.resetGrid('pharmaciesFinder');
		resetForm();
	};

	const handleSubmit = async (values: IFormValues, { resetForm }: any) => {
		console.log('Form values:', values);
		setIsBusy(true);
		//const filters = gridStore.getGridFilters('pharmaciesFinder')!;
		console.log(values.voivodeships)
		ajaxByUser('Successfully downloaded file', () =>
			getEssityApiClient().then((api) =>
				api.report
					.getPharmacyTaxNotes({
						year: values?.year?.year(),
						month: values?.month ? (values?.month!.month() + 1) : undefined,
						voivodeships: values?.voivodeships,
						fileType: values?.fileType,
						// sieveFilters: mapEssityFiltersToSieveFilters(filters),
					})
					.then((result) => {
						DownloadFile({ response: result });
					})
					.finally(() => {
						setVisible(false);
						setIsBusy(false);
						resetForm();
					})
			)
		);
		setTimeout(() => { // Demo: usuń po wdrożeniu powyższej logiki
			setVisible(false);
			setIsBusy(false);
			resetForm();
		}, 2000);
	};

	const isExportDisabled = (values: IFormValues): boolean => {
		return !values.year;
	};

	return (
		<Formik
			initialValues={initialValues}
			onSubmit={handleSubmit}
		>
			{(formikProps) => (
				<>
					<div className={styles.report}>
						<Space direction="vertical">
							<h3>Pharmacy notes report</h3>
							<p>
								Export Pharmacy notes to xlsx or csv file
							</p>
						</Space>
						<Dropdown overlay={menu(formikProps.setFieldValue)} placement="bottomLeft" arrow>
							<Button type="primary" shape="round" size="middle">
								Run
							</Button>
						</Dropdown>
					</div>
					<IsolatedModal
						title="Pharmacy notes report"
						visible={visible}
						onCancel={() => handleCancel(formikProps.resetForm)}
					>
						<Form>
							<Space direction="vertical" className={styles.filters}>
								<div className="fieldbox">
									{/* <FFieldLabel label="Voivodeship" /> */}
									{/* <DictionarySelect
										readOnly={false}
										formikProps={formikProps}
										formikName="voivodeships"
										dictionaryCodeName={DictionariesConstants.Voivodeships}
									/> */}
									<DictionaryFilter
										disabled={
											false
										}
										className={`${styles.item} ${styles.voivodeship}`}
										mode="multiple"
										name="Voivodeship"
										selectedValue={formikProps.values.voivodeships}

										onChange={(items: number[]) =>
											formikProps.setFieldValue('voivodeships', items)
										}
										dictionary={dictionaryStore.getDictionary(
											DictionariesConstants.Voivodeships
										)}
									/>
								</div>
								Settlement period
								<Space direction="horizontal">
									<EssityDatePicker
										picker="month"
										format={DateFormat.Month}
										value={formikProps.values.month}
										onChange={(date) => formikProps.setFieldValue('month', date || undefined)}
									/>
									<EssityDatePicker
										picker="year"
										format={DateFormat.Year}
										value={formikProps.values.year}
										onChange={(date) => formikProps.setFieldValue('year', date || undefined)}
									/>
								</Space>
							</Space>
							<CenteredRow className={styles.exportButton}>
								{isBusy ? (
									<LoadingView message="Creating report, please wait..." />
								) : (
									<Button
										type="primary"
										shape="round"
										size="large"
										htmlType="submit"
										disabled={isExportDisabled(formikProps.values)}
									>
										Generate report
										<CloudDownloadOutlined />
									</Button>
								)}
							</CenteredRow>
						</Form>
					</IsolatedModal>
				</>
			)}
		</Formik>
	);
};
